module.exports = __webpack_public_path__ + "img/ouidah.d36f599d.jpeg";